"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonContainer = exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _close = _interopRequireDefault(require("../../assets/img/close.svg"));
require("./Button.css");
require("./buttonAnimations.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Button = exports.Button = function Button(_ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "b-m" : _ref$size,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? "btn-1" : _ref$styleType,
    animation = _ref.animation,
    borderStyle = _ref.borderStyle,
    align = _ref.align,
    ariaLabel = _ref.ariaLabel,
    ariaPressed = _ref.ariaPressed,
    ariaDisabled = _ref.ariaDisabled,
    ariaExpanded = _ref.ariaExpanded,
    ariaHaspopup = _ref.ariaHaspopup,
    ariaControls = _ref.ariaControls,
    _ref$closeButtonStyle = _ref.closeButtonStyleType,
    closeButtonStyleType = _ref$closeButtonStyle === void 0 ? "btn-1" : _ref$closeButtonStyle,
    closeButtonAnimation = _ref.closeButtonAnimation,
    closeButtonBorderStyle = _ref.closeButtonBorderStyle,
    _ref$isCloseButton = _ref.isCloseButton,
    isCloseButton = _ref$isCloseButton === void 0 ? false : _ref$isCloseButton,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? "button" : _ref$role,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  var alignmentClass = align === "left" ? "button-align-left" : align === "right" ? "button-align-right" : "";
  var buttonClass = "button ".concat(alignmentClass, " ").concat(size, " ").concat(styleType, " ").concat(animation || "", " ").concat(borderStyle || "", " ").concat(className);
  if (isCloseButton) {
    buttonClass += " modal-close-btn ".concat(closeButtonStyleType || "", " ").concat(closeButtonAnimation || "", " ").concat(closeButtonBorderStyle || "");
  }
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: buttonClass.trim(),
    onClick: onClick,
    "aria-label": ariaLabel,
    "aria-pressed": ariaPressed,
    "aria-disabled": ariaDisabled,
    "aria-expanded": ariaExpanded,
    "aria-haspopup": ariaHaspopup,
    "aria-controls": ariaControls,
    role: role,
    tabIndex: tabIndex
  }, isCloseButton ? /*#__PURE__*/_react["default"].createElement("img", {
    src: _close["default"],
    alt: "Close"
  }) : children);
};

// ButtonContainer component
var ButtonContainer = exports.ButtonContainer = function ButtonContainer(_ref2) {
  var align = _ref2.align,
    children = _ref2.children;
  var containerClass = "b-container ".concat(align === "right" ? "b-r" : align === "center" ? "b-c" : align === "left" ? "b-l" : "b-auto");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: containerClass
  }, children);
};